module.exports = __webpack_public_path__ + "static/media/search.66170ff2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/search.svg
// module id = 84
// module chunks = 0